import * as React from "react";
import { IPerformanceNumber } from "../../../types/usageTypes/IPerformanceNumber";
import { IUsageRowData } from "../../../types/usageTypes/IUsageRowData";
import { SizedActionButton } from "../../../components/actionButton/ActionButton";
import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import { Delete20Regular } from "@fluentui/react-icons";

export interface IPerformanceNumbersSectionProps {
    usage: IUsageRowData;
    usageNumberInSearchExclude?: string[];
    isEditable?: boolean;
    onChange?: (performanceNumbers: IPerformanceNumber[]) => void;
}

interface IPerformanceNumbersSectionState {
}

export class PerformanceNumbersSection extends React.PureComponent<
    IPerformanceNumbersSectionProps,
    IPerformanceNumbersSectionState
> {

    constructor(props: IPerformanceNumbersSectionProps) {
        super(props);
        this.state = {
        };
    }

    renderHorizontalRows() {
        const {
            usage,
            usageNumberInSearchExclude = [],
            isEditable = false,
            onChange
        } = this.props

        const rows: JSX.Element[] = [];

        (usage.performanceNumbers || []).forEach((pn: IPerformanceNumber, index: number) => {
            const typeCode = (pn.typeCode || "").trim();
            const number = (pn.number || "").trim();

            if (!isEditable && !number) {
                return;
            }

            if (isEditable || !usageNumberInSearchExclude.includes(typeCode.toUpperCase())) {
                rows.push(
                    <div key={index} className="horizontalRow col-md-3">
                        {isEditable ? (
                            <div className="performanceNumberEditor">
                                <div className="performanceNumberInputs form-group col-md-10 col-sm-6 col-xs-12">
                                    <div className="performanceNumberInput">
                                        <label htmlFor={`performance-number-type-${index}`}>Type</label>
                                        <input id={`performance-number-type-${index}`} className="form-control" aria-label="Performance number type" value={pn.typeCode || ""} onChange={event => {
                                            const performanceNumbers = [...usage.performanceNumbers];
                                            performanceNumbers[index] = { ...performanceNumbers[index], typeCode: event.target.value };
                                            onChange?.(performanceNumbers);
                                        }} />
                                    </div>
                                    <div className="performanceNumberInput">
                                        <label htmlFor={`performance-number-value-${index}`}>Value</label>
                                        <input id={`performance-number-value-${index}`} className="form-control" aria-label="Performance number value" value={pn.number || ""} onChange={event => {
                                            const performanceNumbers = [...usage.performanceNumbers];
                                            performanceNumbers[index] = { ...performanceNumbers[index], number: event.target.value };
                                            onChange?.(performanceNumbers);
                                        }} />
                                    </div>
                                </div>
                                <IconTextButton
                                    
                                    icon={Delete20Regular}
                                    text="Delete"
                                    tooltip="Delete performance number"
                                    onClick={() => onChange?.(usage.performanceNumbers.filter((_, itemIndex) => itemIndex !== index))}
                                />
                            </div>
                        ) : (
                            <>
                                {typeCode && <label className="section col-md-12">{typeCode}:</label>}
                                {number && <p className="section col-md-12">{number}</p>}
                            </>
                        )}
                    </div>
                );
            }
        });

        return rows;
    }

    render() {
        const {

        } = this.props;
        const horizontalRows = this.renderHorizontalRows();
        const { isEditable = false, onChange, usage } = this.props;

        return (
            <div className="performanceNumbers col-md-12" id={`performance-numbers-section`}>
                <div className="container">
                <h3>Performance Numbers</h3>
                    {horizontalRows}
                    {isEditable && <SizedActionButton
                        type="button"
                        buttonText="Add New"
                        buttonAction={() => onChange?.([...(usage.performanceNumbers || []), { typeCode: "", number: "" }])}
                    />}
                </div>
            </div>
        );

    }
}